import { Check, Clear } from '@mui/icons-material';
import {
    useAcceptContractorInviteMutation,
    useDeclineContractorInviteMutation,
    useGetContractorClientsQuery,
    useGetContractorInvitesQuery,
} from '../../../../app/Slices/SevenDayApiSlice';
import {
    Box,
    Button,
    ButtonGroup,
    Card,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import toast from '../../../shared/Toast';
import UserRole from '../../../../shared/AuthRoles';
import PendingInvites from './PendingInvites';

const ClientList = () => {
    const loggedInUser = UserRole();

    const { data: clients } = useGetContractorClientsQuery(
        loggedInUser.company,
        { skip: !loggedInUser?.company },
    );

    return (
        <Stack sx={{ pt: '30px', gap: 4 }}>
            <PendingInvites />
            <Box component='section' aria-labelledby='your-clients-heading'>
                <Typography
                    id='your-clients-heading'
                    variant='subHeading'
                    component='h2'
                >
                    Your Clients
                </Typography>
                {clients && clients.length > 0 ? (
                    <List disablePadding>
                        {clients.map((client: any) => (
                            <ListItem divider disableGutters>
                                <ListItemText primary={client.name} />
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Card variant='outlined'>
                        <Box
                            sx={{
                                p: 4,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            No active clients.
                        </Box>
                    </Card>
                )}
            </Box>
        </Stack>
    );
};

export default ClientList;
